import { defineRecipe } from '@chakra-ui/react';

export const inputRecipe = defineRecipe({
  base: {
    width: '100% !important',
  },
});

export default inputRecipe;
